import { LoaderFunction, redirect } from 'react-router-dom';
import { captureMessage } from '@sentry/react';
import { isUrlValidElseRaiseError } from '../utils/redirect';
import { api } from '../utils/fetchApi';

export const beginAuthorizationLoader: LoaderFunction = async ({
  request: { url },
}) => {
  const token = new URL(url).searchParams.get('token');
  if (!token) {
    throw Error('Missing token');
  }

  const response = await api({
    url: `/api/connect/remote/authorize`,
    method: 'POST',
    body: { authorization_token: token },
  });
  const redirectUrl = (await response.json()).redirect_url;
  isUrlValidElseRaiseError(redirectUrl);
  captureMessage(`Safely redirecting user to: ${redirectUrl}`, 'debug');
  return redirect(redirectUrl);
};

export const validateAuthorizationLoader: LoaderFunction = async ({
  request: { url },
}) => {
  const searchParams = new URL(url).searchParams;
  const code = searchParams.get('code');
  const state = searchParams.get('state');

  if (!code) {
    throw Error('Missing token');
  }

  if (!state) {
    throw Error('Missing state');
  }

  const response = await api({
    url: '/api/connect/remote/authorize/confirm',
    method: 'POST',
    body: { authorization_code: code, validation_state: state },
  });

  const redirectUrl = (await response.json()).redirect_url;
  isUrlValidElseRaiseError(redirectUrl);
  captureMessage(`Safely redirecting user to: ${redirectUrl}`, 'debug');
  return redirect(redirectUrl);
};
